import classNames from 'classnames/bind';
import { FC } from 'react';
import style from './JDProcess.module.scss';
const cx = classNames.bind(style);

interface IProps {
  show?: boolean;
  label: string;
  text: string;
}

export const JDProcessItem: FC<IProps> = ({ show, label, text }) => {
  if (!show) return null;
  if (!label || !text) return null;
  return (
    <li>
      <div className={cx('label')}>{label}</div>
      <div className={cx('text')}>{text}</div>
    </li>
  );
};

export default JDProcessItem;
